import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from "primeng/api";
import { SelectItem } from 'primeng/api';
import { ProposalService } from 'src/app/Services/ProposalService/ProposalService.service';
import { PortfolioProductViewModel } from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { ArtistProductsService, ArtistProductSummary } from 'src/app/Services/artistproducts.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService, FCMNotificationActionGroupEnum, ResponseObject } from 'src/app/Services/auth.service';
import { CategoryService } from 'src/app/Services/category.service';
import { ConnectedGallery, ConnectionsService } from 'src/app/Services/connections.service';
import { ConsignmentService, Consignment, FetchConsignmentsRequestParam, ConsignmentProposalRequest, AcceptProposalProduct, ProposalHistoryResponse, ConsignmentProposalProduct } from 'src/app/Services/consignment.service';
import { GalleriesService } from 'src/app/Services/galleries.service';
import { MessagingService } from 'src/app/Services/messaging.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { ImageUrls, NotificationTypes } from 'src/app/app.enums';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { ImageUtils } from 'src/app/shared/utils/image-utils';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-gallery-proposal',
    templateUrl: './gallery-proposal.component.html',
    styleUrls: ['./gallery-proposal.component.css'],
    providers: [CategoryService, ConsignmentService, ConnectionsService, GalleriesService],
    standalone: false
})
export class GalleryProposalComponent implements OnInit {
  public isLoading: boolean = true;
  public artistId!: string;
  public isProductSelected: boolean = false;
  public consignmentProposals: ConsignmentProposalRequest[] = [];
  public consignment: Consignment;
  public artists: SelectItem[] = [];
  public authConfig: AuthConfig = {};
  public consignmentProposalProductsDialogVisible: boolean = false;
  public selectedConsignmentProposal: ConsignmentProposalRequest | null = null;
  public isSelectedProposalAccepted = false;
  public consignmentProposalProducts: ArtistProductSummary[] = [];
  public ConsignmentProposalProduct: ConsignmentProposalProduct[] = [];
  public productMiniDialogVisible: boolean = false;
  public selectedArtworkProduct: ArtistProductSummary | null = null;
  public consignmentProposalStatusItems: SelectItem[] = [];
  public filters: FetchConsignmentsRequestParam = {};
  public showAddCommentsDialog: boolean = false;
  public showRejectProposalDialog: boolean = false;
  public galleryComment: string | null = null;
  public isProposalAccepted: boolean = false;
  public isSendPurposalDailogVisible: boolean = false;
  public isCurrentInventoryLoaded: boolean = false;
  public connectedGalleries: SelectItem[] = [];
  public selectedGalleryId: string | null = null;
  public galleryId!: string;
  public currentConsignmentProposal: number = 0;
  public artistConnectedGalleries: SelectItem[] = [];
  public consignmentProposalData: ConsignmentProposalRequest = {} as ConsignmentProposalRequest;
  public selectedPurposalInventory: ArtistProductSummary[] = [];
  public checked: boolean = false;
  public selectedProductId: string[] = [];
  public AcceptProposalProductData: AcceptProposalProduct = {} as AcceptProposalProduct;
  public showProposalHistory: boolean = false;
  public proposalHistory: ProposalHistoryResponse[] = [];
  constructor(private router: Router,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private ngxSpinnerService: NgxSpinnerService,
    private artistService: ArtistsService,
    private consignmentService: ConsignmentService,
    private ProposalService: ProposalService,
    private galleriesService: GalleriesService,
    private notificationsService: NotificationsService,
    private messagingService: MessagingService,

    private connectionsService: ConnectionsService,
    private ArtistProductsService: ArtistProductsService,
    private transloco: TranslocoService) {
    this.consignment = new Consignment();
  }

  public ngOnInit(): void {
    this.reciveNotifications()
    this.authConfig = this.authService.getAuthConfig();
    //get all the consignments (of logged-in user)
    if (this.authConfig.IsArtist) {
      this.ViewConsignmentProposals();
      this.galleryDropdownData();

    }
    if (this.authConfig.IsGallery) {
      this.ViewConsignmentProposals();
      this.getConnectedArtists();
    }
    if (this.authConfig.IsArtist) {
      this.artistId = this.authService.getUserId();
    }
    if (this.artistId) {
      this.getAllGalleries(this.artistId)
    }


    this.consignmentProposalStatusItems = [];
    this.consignmentProposalStatusItems.push({ label: 'Pending', value: 'Pending' });
    this.consignmentProposalStatusItems.push({ label: 'Accepted', value: 'Accepted' });
    this.consignmentProposalStatusItems.push({ label: 'Declined', value: 'Rejected' });
  }


  public reciveNotifications() {
    this.messagingService.handleMarkasReadByActionType(FCMNotificationActionGroupEnum.Proposal);
  }




  private getAllGalleries(artistId: string | null) {
    this.ngxSpinnerService.show();
    this.connectionsService.getConnectedGalleries(artistId, false).subscribe((galleries: ConnectedGallery[]) => {
      this.artistConnectedGalleries = galleries.map((gallery) => ({ label: gallery.Name, value: gallery.Id }));
      console.log(this.artistConnectedGalleries)
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }


  public onOpenSendProposalDialog() {
    this.isSendPurposalDailogVisible = true;
    this.consignmentProposalData.ArtistId = this.artistId;
    this.initalizeInventoryLists(this.artistId, true);

  }


 private initalizeInventoryLists(artistId: string, isInitialCall: boolean) {
  this.isCurrentInventoryLoaded = false;
  this.consignmentProposalProducts = [];
  this.selectedPurposalInventory = [];

  // Get all the products of this artist
  this.getArtistProducts(artistId, (artistProducts: ArtistProductSummary[]) => {
    this.consignmentProposalProducts = artistProducts.map((product) => {
      product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
      return product;
    });
    console.log(this.consignmentProposalProducts);
    this.isCurrentInventoryLoaded = true;
  });
}
  public getArtistProducts(artistId: string, callback: Function) {
    this.ArtistProductsService.getArtistProducts(artistId, true).subscribe((artistProducts) => {
      //call the callback function because we still need to load the consignment products
      callback(artistProducts);
    }, (error) => { console.error(error); callback([]); });
  }

  public selectInventory(event: ArtistProductSummary) {
    // Check if the selected inventory item is not already in the array
    if (!this.selectedPurposalInventory.some(item => item.Id === event.Id)) {
      // Move the product to selectedInventory
      this.selectedPurposalInventory.push(event);
      // Remove the selected item from currentInventory
      const index = this.consignmentProposalProducts.findIndex(item => item.Id === event.Id);
      if (index !== -1) {
        this.consignmentProposalProducts.splice(index, 1);
      }
      this.isProductSelected = true;

      // Update the ConsignmentProducts array
      this.consignment.SelectedProductIds = this.selectedPurposalInventory.map(p => p.Id);
    }
    console.log("Selected Inventory", this.consignment);
  }

  public moveToCurrentInventory(selectedPurposalInventory: ArtistProductSummary) {
    // Find the index of the item in the selectedInventory array
    const currentIndex = this.selectedPurposalInventory.findIndex(item => item.Id === selectedPurposalInventory.Id);

    // If the item is found, remove it from selectedInventory and add it to currentInventory
    if (currentIndex !== -1) {
      const removedItem = this.selectedPurposalInventory.splice(currentIndex, 1)[0];
      this.consignmentProposalProducts.push(removedItem);
    }
    this.isProductSelected = this.selectedPurposalInventory.length > 0;

  }


  private ViewConsignmentProposals(filters: FetchConsignmentsRequestParam = {}) {
    this.isLoading = true;
    this.ngxSpinnerService.show();
    this.ProposalService.ViewConsignmentProposal(filters).subscribe((proposals) => {
      this.consignmentProposals = proposals;
      this.currentConsignmentProposal = this.consignmentProposals.length;
      console.log(this.consignmentProposals);
      this.isLoading = false;
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.isLoading = false; this.ngxSpinnerService.hide(); });
  }

  private getConnectedArtists() {
    this.artists = [];
    this.artistService.getArtistsDropdownData().subscribe((artists) => {
      this.artists = artists;
    }, (error) => { console.error(error); });
  }

  public openViewConsignmentProposalProductsDialog(rowData: ConsignmentProposalRequest) {
    this.selectedConsignmentProposal = rowData;
    console.log('IsGalleryInteracted: ' + this.selectedConsignmentProposal.IsGalleryInteracted);
    this.getConsignmentProducts(this.selectedConsignmentProposal.Id);
    this.consignmentProposalProductsDialogVisible = true;
  }

  public closeConsignmentProposalProductsDialog() {
    this.consignmentProposalProductsDialogVisible = false;
    this.selectedConsignmentProposal = null;
    this.ConsignmentProposalProduct = [];
  }


  public showCommentsDialog(rowData: ConsignmentProposalRequest, isAccepted: boolean) {
    this.selectedConsignmentProposal = rowData;
    this.isSelectedProposalAccepted = isAccepted;
    this.router.navigate(['/proposal-selection', this.selectedConsignmentProposal.Id]);

  }



  public showConsignmentProposalLogHistory(proposalId: string) {
    this.ngxSpinnerService.show();
    this.ProposalService.showConsignmentProposalLogHistory(proposalId).subscribe((response: ProposalHistoryResponse[]) => {
      this.ngxSpinnerService.hide();
      this.proposalHistory = response;
      console.log("Log Response", response);

    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }


  public consignmentProposalDialog(selectedproposal: ProposalHistoryResponse) {
    this.showProposalHistory = true;
    this.showConsignmentProposalLogHistory(selectedproposal.Id);
  }

  private createConsignmentDraft(selectedConsignmentProposal: ConsignmentProposalRequest) {
    this.ngxSpinnerService.show();
    const consignmentData = {
      Name: `${this.formatCurrentDate()}-${selectedConsignmentProposal?.GalleryUserName}`,
      ConsignmentStatus: 'Draft', // Save as draft
      GallerySaleType: '',
      SalesTaxPercentage: 0,
      Commission: 0,
      SelectedProductIds: this.AcceptProposalProductData.acceptedproductIds
    };

    this.consignmentService.createConsignment(selectedConsignmentProposal.ArtistId, selectedConsignmentProposal.GalleryId!, consignmentData).subscribe((response) => {
      this.ngxSpinnerService.hide();
      if (response.Success && response.ResponseData) {
        const consignmentId = response.ResponseData;
        // Redirect the user to the newly created consignment if needed
        // this.router.navigate(['artists', 'consignments', consignmentId, 'view']);
        this.notificationsService.showNotification(this.transloco.translate('galleryProposal.success'), this.transloco.translate('galleryProposal.consignmentCreated'), NotificationTypes.Success);
      } else {
        console.error(response);
        this.notificationsService.showNotification(this.transloco.translate('galleryProposal.error'), this.transloco.translate('galleryProposal.errorSavingConsignment'), NotificationTypes.Error);
      }
    }, (error) => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }

  public formatCurrentDate(): string {
    const currentDate = new Date();
    return formatDate(currentDate, 'dd-MM-yy', 'en-US');
  }

  public displayEmojiDialog: boolean = false
  public activeCommentField: 'ArtistComment' | 'galleryComment' = 'ArtistComment';

  public sendConsignmentProposal() {
    this.consignmentProposalData.SelectedProductIds = this.selectedPurposalInventory.map(p => p.Id);
    this.consignmentProposalData.GalleryId = this.galleryId;
    console.log(this.consignmentProposalData);
    this.ngxSpinnerService.show();
    this.ProposalService.sendConsignmentProposal(this.consignmentProposalData).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.ViewConsignmentProposals();
        this.consignmentProposalData = {} as ConsignmentProposalRequest;
        this.onCloseSendPurposalDailog(); // Close the dialog and reset data

        // Refresh the product list
        if (this.artistId) {
          this.initalizeInventoryLists(this.artistId, false);
        }

        this.notificationsService.showNotification(this.transloco.translate('galleryProposal.success'), this.transloco.translate('galleryProposal.proposalSent'), NotificationTypes.Success);
      } else {
        this.notificationsService.showNotification(this.transloco.translate('galleryProposal.error'), this.transloco.translate('galleryProposal.errorSendingProposal', { details: response.ResponseMessage }), NotificationTypes.Error);
      }
    }, (error) => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }

  public sendGalleryComment() {
    // Implement the logic to send the gallery comment
    console.log('Gallery Comment:', this.galleryComment);
    // Reset the gallery comment after sending
    this.galleryComment = '';
  }
  public openEmojiDialog(commentField: 'ArtistComment' | 'galleryComment') {
    this.activeCommentField = commentField;
    this.displayEmojiDialog = !this.displayEmojiDialog;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    if (this.activeCommentField === 'ArtistComment') {
      this.consignmentProposalData.ArtistComment = (this.consignmentProposalData.ArtistComment || '') + emoji;
    } else {
      this.galleryComment = (this.galleryComment || '') + emoji;
    }
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }

  public onCloseSendPurposalDailog() {
    this.consignment.GalleryId = '';
    this.consignmentProposalData = {} as ConsignmentProposalRequest; // Reset the proposal data
    this.selectedPurposalInventory = [];
    this.isSendPurposalDailogVisible = false;

    // Refresh the product list
    if (this.artistId) {
      this.initalizeInventoryLists(this.artistId, false);
    }
  }

  public onProductMiniDialogClosed($event: any) {
    this.productMiniDialogVisible = false;
    this.selectedArtworkProduct = null;
  }

  public onArtistChanged($event: any) {
    this.filters.ArtistId = $event.value;
    this.ViewConsignmentProposals(this.filters);
  }

  public onGalleryChanged($event: any) {
    if (!this.isSendPurposalDailogVisible) {
      this.filters.GalleryId = $event.value;
      this.galleryId = $event.value;
      this.ViewConsignmentProposals(this.filters);
    }
    else {
      this.filters.GalleryId = $event.value;
      this.galleryId = $event.value;
    }

  }

  public onStatusChange($event: any) {
    this.filters.Status = $event.value!;
    this.ViewConsignmentProposals(this.filters);
  }
  public galleryDropdownData() {
    this.galleriesService.fetchDropdownData().subscribe((galleries) => {
      this.connectedGalleries = galleries;
    }, (error) => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }



  public goToProductDetails(product: ConsignmentProposalProduct) {
    this.router.navigate(['/', product.ArtistProduct_ArtistId, 'artworks', product.ArtistProductId]);
  }


  public goToProductDetail(product: ConsignmentProposalProduct) {
    this.router.navigate(['/', product.ArtistProduct_ArtistId, 'artworks', product.ArtistProductId]);
  }

  isToday(date: Date): boolean {
    const today = new Date();
    const providedDate = new Date(date);
    return providedDate.getFullYear() === today.getFullYear() && providedDate.getMonth() === today.getMonth() && providedDate.getDate() === today.getDate();
  }

  proposedDaysAgo(date: Date): number {
    const currentDate = new Date();
    const proposedDate = new Date(date);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const daysAgo = Math.round(Math.abs((currentDate.getTime() - proposedDate.getTime()) / oneDay));
    return daysAgo;
  }

  public closeAddCommentsDialog($event: any) {
    this.showAddCommentsDialog = false;
    this.galleryComment = null;
  }

  // public showProductDetail(artistProduct: ArtistProduct) {
  //   this.router.navigate([artistProduct.ArtistId, 'artworks', artistProduct.Id]);
  // }

  public selectedProduct!: ArtistProductSummary;
  public showProductDialog = false;
  public PortfolioProductViewModel!: PortfolioProductViewModel

  public closeProductDialog() {
    this.showProductDialog = false;
    console.log('Full screen image dialog closed');
  }

  public selectdProductId: any;

  public showProductDetail(selectedProductId: string): void {
    console.log('selectedProductId', selectedProductId)
    this.selectdProductId = selectedProductId;
    this.showProductDialog = true;
  }

  public openAddCommentsDialog() {
    this.showAddCommentsDialog = true;
  }
  public submitProposalWithComment() {
    this.showAddCommentsDialog = false;
    this.sendConsignmentProposal();
  }
  public isDispatchedButtonVisible = false;

  public getConsignmentProducts(consignmentProposalId: string) {
    this.consignmentProposalProducts = [];
    this.ngxSpinnerService.show();
    this.ProposalService.getConsignmentProposalProducts(consignmentProposalId).subscribe(
      (consignmentProposalProducts) => {
        this.ConsignmentProposalProduct = consignmentProposalProducts;
        this.ConsignmentProposalProduct = consignmentProposalProducts.map((product) => {
          product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ArtistProduct_ProductImgUrl || 'assets/images/No-Image.png');
          return product;
        });

        // Set IsProposalAccepted based on accepted products
        this.selectedConsignmentProposal!.IsProposalAccepted = this.ConsignmentProposalProduct.some(p => p.IsAccpted);

        this.isDispatchedButtonVisible = this.ConsignmentProposalProduct.some(p => p.IsAccpted);

        console.log("ConsignmentProposalProduct", this.ConsignmentProposalProduct[0].ConsignmentProposal?.ConsignmentId); // Check console to verify data
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public PrepareDispatchDocuments(): void {
    if (!this.selectedConsignmentProposal) {
      this.notificationsService.showNotification(this.transloco.translate('galleryProposal.error'), this.transloco.translate('galleryProposal.noProposalSelected'), NotificationTypes.Error);
      return;
    }

    this.ngxSpinnerService.show();

    this.ProposalService.createConsignment(this.selectedConsignmentProposal.Id).subscribe({
      next: (response: ResponseObject) => {
        this.ngxSpinnerService.hide();

        if (response?.Success) {
          this.notificationsService.showNotification(this.transloco.translate('galleryProposal.success'), this.transloco.translate('galleryProposal.dispatchDocsPrepared'), NotificationTypes.Success);

          // Dialog close
          this.consignmentProposalProductsDialogVisible = false;

          // Get consignmentId from API response
          const consignmentId = response.ResponseData?.ConsignmentId || response.ResponseData || null;

          console.log('ConsignmentId:', consignmentId);

          if (consignmentId) {
            this.router.navigate(['/artists', 'consignments', consignmentId, 'view']);
          }
        } else {
          this.notificationsService.showNotification(this.transloco.translate('galleryProposal.error'), response?.ResponseMessage || this.transloco.translate('galleryProposal.failedToPrepareDispatchDocs'), NotificationTypes.Error);
        }
      },
      error: (error) => {
        this.ngxSpinnerService.hide();
        this.notificationsService.showNotification(this.transloco.translate('galleryProposal.error'), this.transloco.translate('galleryProposal.errorPreparingDispatchDocs'), NotificationTypes.Error);
        console.error(error);
      }
    });
  }
  

}